"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.faFilter = void 0;
var faFilter = {
  prefix: 'fal',
  iconName: 'faFilter',
  icon: [512, 512, [], '', 'M479.3 32H32.7C5.213 32-9.965 63.28 7.375 84.19L192 306.8V400c0 7.828 3.812 15.17 10.25 19.66l80 55.98C286.5 478.6 291.3 480 295.9 480C308.3 480 320 470.2 320 455.1V306.8l184.6-222.6C521.1 63.28 506.8 32 479.3 32zM295.4 286.4L288 295.3v145.3l-64-44.79V295.3L32.7 64h446.6l.6934-.2422L295.4 286.4z']
};
exports.faFilter = faFilter;